// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea-root-3OCnn","fullwidth":"Textarea-fullwidth-3HNab"};